import {  Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Location } from '@angular/common';
import { PermissionService } from '../services/permission-service.service';
import { BehaviorSubject, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManualNavigationGuard implements CanActivate {
  isHiddenData: any;
  SETTINGSItems: any;
  urlAccessPermission: any;
  public sideMenubarSub = new BehaviorSubject<any[]>([]);

  constructor(private router: Router, private location: Location, private permissionService: PermissionService) {
    console.log("Guard constructor called");
    this.initializeData();
  }

  private initializeData() {
    console.log("Starting initialization");
    this.sideMenuInitilize().then(() => {
      console.log("sideMenuInitilize completed");
      this.getSideMenuBar().subscribe({
        next: (SETTINGSItems: any) => {
          console.log("Subscription received data:", SETTINGSItems);
          this.isHiddenData = SETTINGSItems;
          console.log("AccessUrl:", this.isHiddenData);
          this.SETTINGSItems = SETTINGSItems.filter(item => !item.isHidden);
          console.log("Filtered SETTINGSItems:", this.SETTINGSItems);
        },
        error: (error) => {
          console.error("Error in subscription:", error);
        }
      });
    }).catch(error => {
      console.error("Error in initialization:", error);
    });
  }

  async sideMenuInitilize() {
    try {
      console.log("Starting sideMenuInitilize");
      const res = await this.permissionService.getResourceCategoryById("AccessUrl") as any;
      console.log("Received response from getResourceCategoryById:", res);
      const data = res;
      const resourceTypes = data?.resource_types;
      if (Array.isArray(resourceTypes) && resourceTypes.length > 0) {
        this.urlAccessPermission = resourceTypes[0]?.resources || [];
        console.log("Setting urlAccessPermission:", this.urlAccessPermission);
        const mappedMenuItems = this.mapedMenuItems();
        console.log("Mapped menu items:", mappedMenuItems);
        this.sideMenubarSub.next(mappedMenuItems);
      } else {
        console.error("Resource types array is empty or not defined");
      }
    } catch (error) {
      console.error("Error in sideMenuInitilize:", error);
      throw error;
    }
  }

  mapedMenuItems() {
    return this.urlAccessPermission.map(el => {
      let tempData = {}
      let lastIndex = el.resource_permission.length - 1;
      let isHidden = el.resource_permission[0]?.CanView || 0;
      if (el.children.length == 0) {
        tempData = {
          title: el.DisplayName,
  
          //isHidden: this.getPermission(el),
          // isHidden: convertToBoolean(this.getPermission(el)),
  
          isHidden,
          // isHidden: convertToBoolean(el.HideMenu),
  
          icon: el.NavIconClass,
          type: "link",
          badgeType: "light-success",
          path: el.UrlRoute
        }
  
  
      } else {
        tempData = {
          title: el.DisplayName,
  
          //isHidden: this.getPermission(el),
  
          isHidden,
  
          icon: el.NavIconClass,
          type: "sub",
          badgeType: "light-success",
          path: el.UrlRoute,
          badgeValue: el.children?.length,
          children: el.children.map(el2 => {
            return {
              path: el2.UrlRoute, title: el2.DisplayName, type: "link"
            }
          })
        }
      }
  
      return tempData
    })
  }

  getSideMenuBar() {
    return this.sideMenubarSub.asObservable();
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    console.log("canActivate called with state.url:", state.url);
  
    // Wait for permission data
    if (!this.isHiddenData || this.isHiddenData.length === 0) {
      console.log("⏳ Waiting for permission data...");
      const menuData = await firstValueFrom(this.getSideMenuBar());
      this.isHiddenData = menuData;
      console.log("✅ Permission data loaded:", this.isHiddenData);
    }
  
    // Now continue with access logic
    if (this.isHiddenData[0]?.isHidden) {
      return true;
    }
  
    const navigationState = this.location.getState();
    const lastNavigation = sessionStorage.getItem('lastNavigation');
  
    if (!navigationState || Object.keys(navigationState).length === 0) {
      console.log("🚨 Redirecting to /unauthorized due to manual entry");
      this.router.navigate(['/unauthorized']);
      return false;
    }
  
    if (lastNavigation !== 'app' && lastNavigation !== state.url) {
      console.log("🚨 Redirecting due to invalid last navigation");
      this.router.navigate(['/unauthorized']);
      return false;
    }
  
    return true;
  }
  
}
